/**
 * Service to generate calendar event links and files (Google, Outlook, iCal)
 */

const calendarService = {
    /**
     * Format date to YYYYMMDDTHHMMSSZ for Google/Outlook
     */
    formatDate: (date) => {
        return new Date(date).toISOString().replace(/-|:|\.\d\d\d/g, "");
    },

    /**
     * Generate Google Calendar URL
     */
    generateGoogleUrl: (event) => {
        const { title, description, location, startTime, endTime } = event;
        const start = calendarService.formatDate(startTime);
        const end = calendarService.formatDate(endTime || new Date(new Date(startTime).getTime() + 2 * 60 * 60 * 1000)); // Default 2h

        return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&dates=${start}/${end}`;
    },

    /**
     * Generate Outlook.com Calendar URL
     */
    generateOutlookUrl: (event) => {
        const { title, description, location, startTime, endTime } = event;
        const start = calendarService.formatDate(startTime);
        const end = calendarService.formatDate(endTime || new Date(new Date(startTime).getTime() + 2 * 60 * 60 * 1000));

        return `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(title)}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&startdt=${start}&enddt=${end}`;
    },

    /**
     * Generate iCal (.ics) data and trigger download
     */
    downloadICal: (event) => {
        const { title, description, location, startTime, endTime, url: eventUrl } = event;
        const start = calendarService.formatDate(startTime);
        const end = calendarService.formatDate(endTime || new Date(new Date(startTime).getTime() + 2 * 60 * 60 * 1000));

        const icsContent = [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "PRODID:-//NovaInk//Tattoo Platform//PT",
            "CALSCALE:GREGORIAN",
            "METHOD:PUBLISH",
            "BEGIN:VEVENT",
            `DTSTART:${start}`,
            `DTEND:${end}`,
            `DTSTAMP:${calendarService.formatDate(new Date())}`,
            `SUMMARY:${title}`,
            `DESCRIPTION:${description.replace(/\n/g, "\\n")}`,
            `LOCATION:${location}`,
            eventUrl ? `URL:${eventUrl}` : "",
            "STATUS:CONFIRMED",
            "SEQUENCE:0",
            "END:VEVENT",
            "END:VCALENDAR"
        ].filter(Boolean).join("\r\n");

        const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${title.replace(/\s+/g, "_")}.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
};

export default calendarService;
